export class ApiBaseUrlConfigError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ApiBaseUrlConfigError'
  }
}

type ApiEnv = {REACT_APP_API_URL?: string}

/**
 * Single source of the REST/Socket base URL. No fallback host: a missing or
 * malformed REACT_APP_API_URL must fail at startup instead of silently
 * targeting localhost or a relative "undefined/api/..." path.
 */
export function resolveApiBaseUrl(env: ApiEnv = process.env as ApiEnv): string {
  const raw = (env.REACT_APP_API_URL || '').trim()
  if (!raw) {
    throw new ApiBaseUrlConfigError('REACT_APP_API_URL is not set. Configure it in .env (e.g. https://api.maarefati.com).')
  }
  let parsed: URL
  try {
    parsed = new URL(raw)
  } catch {
    throw new ApiBaseUrlConfigError(`REACT_APP_API_URL is not a valid absolute URL: "${raw}".`)
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    throw new ApiBaseUrlConfigError(`REACT_APP_API_URL must use http or https: "${raw}".`)
  }
  return raw.replace(/\/+$/, '')
}
